// Chèque
export const CHEQUE = 'CHB';
// Numéraire
export const NUMERAIRE = 'NUM';
// Carte bancaire
export const CARTE_BANCAIRE = 'CBA';
// CESU
export const CESU = 'CES';
// Chèque vacances
export const CHEQUE_VAC = 'CHV';
// Bon CCAS
export const BON_CCAS = 'BCS';
// Bon CAF
export const BON_CAF = 'BCF';
// Tickets
export const TICKET = 'TIC';
// Virement
export const VIREMENT = 'VIR';

// Modes de règlement à restriction unique (un seul autorisé par encaissement).
// CESU et chèque vacances n'y sont pas : un payeur peut remettre des titres de valeurs différentes.
export const RESTRICTION_UNIQUE = [NUMERAIRE, VIREMENT];

// Titres de paiement réservés aux produits éligibles, avec le drapeau du produit qui porte
// cette éligibilité (REG-861 / REG-862). Un drapeau absent ou nul vaut non éligible.
export const ELIGIBILITE_TITRES = {
  [CESU]: { drapeau: 'payableCESU', libelle: 'CESU' },
  [CHEQUE_VAC]: { drapeau: 'payableChequeVacance', libelle: 'chèque vacances' },
} as const;

// ------ ci-dessous pas dans l'encaissement ------ //

// Prélèvement
export const PRELEVEMENT = 'PRE';
// Carte bancaire par internet
export const CARTE_BANCAIRE_INTERNET = 'CBI';
// Prélèvement par internet
export const PRELEVEMENT_INTERNET = 'PRI';
// Règlement interne
export const REGLEMENT_INTERNE = 'INT';
